export default __webpack_public_path__ + "static/media/farida.17477ccd.jpg";